import { TextInput as RNTextInput } from "react-native-web";
import { tokens } from "@opendoor/tokens-studio/dist/bricks-next/tokens/Components";
import { isWeb, styled } from "@tamagui/core";
const {
    textInput: textInputTokens
  } = tokens,
  TextInputField = styled(RNTextInput, {
    focusable: !0,
    borderWidth: 0,
    outlineStyle: "none",
    fontFamily: "$body",
    placeholderTextColor: textInputTokens.color.content.placeholderText.default,
    // This is a workaround for a style set by primer.css
    // @ts-expect-error - RNTextInput does not have a boxShadow prop
    boxShadow: isWeb ? "none" : void 0,
    variants: {
      size: size => ({
        fontSize: textInputTokens.typography.valueText[size],
        fontWeight: textInputTokens.typography.valueText[size],
        letterSpacing: textInputTokens.typography.valueText[size]
      })
    }
  }, {
    isInput: !0,
    accept: {
      placeholderTextColor: "color"
    }
  });
export { TextInputField };